/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { NextPage } from 'next';
import { Container } from 'styled-bootstrap-grid';
import styled from 'styled-components';
import loadNamespaces from 'next-translate/loadNamespaces';
import { withAuthSync } from '../../utils/auth';
import PostBySlug from '../../components/Music-knowledge-hub/PostBySlug';
import { VirpPageContext } from '../_app';

const MusicKnowledgeHub: NextPage = () => (
  <StyledContainer fluid>
    <PostBySlug />
  </StyledContainer>
);

const StyledContainer = styled(Container)`
  max-width: 1360px;
  width: 100%;
  margin: 0 auto;
`;

MusicKnowledgeHub.getInitialProps = async (ctx: VirpPageContext) => {
  const getTranslations = await loadNamespaces({
    ...ctx,
    pathname: '/music-knowledge-hub/[slug]',
  });
  return { ...getTranslations };
};

export default withAuthSync(MusicKnowledgeHub, {
  protected: false,
});
